const DEFAULT_INSTALLATION_NAME = "Seam-Chat";

export function replaceSeamChatBranding(message) {
  if (typeof message !== "string") return message;
  const installationName =
    typeof window !== "undefined" && window.globalConfig?.INSTALLATION_NAME
      ? window.globalConfig.INSTALLATION_NAME
      : DEFAULT_INSTALLATION_NAME;
  return message.replace(/chatwoot/gi, installationName);
}
